import {gql} from "@apollo/client";

export const DELETE_FILE = gql`
	mutation deleteFile($id: Int!,$entityType: EntityType!, $fileName: String!)
	{
	   deleteFile(input: {id :$id, entityType: $entityType,fileName: $fileName}) {boolean}
	}
`;
